import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";

export const adaptador_lista_exportacion = (listas) => {


    let arr = []
    for (let i = 0; i < listas.length; i++) {
        let lista = listas[i]
        let obj = {
            fecha: formatoFechaExportacion(lista.fecha),
            conductor: lista.nombres + ' ' + lista.apellidos,
            cc: lista.cc,
            tipo: lista.tipo,
            placa: lista.placa,
            marca: lista.marca,
            modelo: lista.modelo,
            cilindraje: lista.cilindraje

        }
        arr.push(obj)
    }

    return arr

}